import { NgModule } from '@angular/core';
import { ThaiBahtPipe } from './thaibaht.pipe';

@NgModule({
  declarations: [ThaiBahtPipe],
  exports: [ThaiBahtPipe]
})
export class ThaiBahtPipeModule { }
